import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import DataForm from './DataForm';
import APIUtilities from './APIUtilities.js'
import { track } from './posthog';
import {
  BrowserRouter as Router,
  Route,
  Link,
  useParams,
  useHistory
} from "react-router-dom";

import "./RecapPage.css";
import DiscountBadge from "./DiscountBadge";
import proctection_LIST from "./_ProtectionList.json";
import { normaliserParametres, calculerRemisesParItem, calculerPrixNet } from './calculRemises';

class RecapPage extends PureComponent {
  static propTypes = {
    category: PropTypes.object,
    brand: PropTypes.object,
    model: PropTypes.object,
    selectedItems: PropTypes.array,
    discount: PropTypes.number,
    total: PropTypes.number,
    GUID: PropTypes.string,
    onClickFunction: PropTypes.func
  };

  constructor (props) {
    super(props);
    this.state = {
      discountHelperText: '',
      discountError: false,
      // Saisie brute du champ (contrôlée) et code effectivement validé par le
      // serveur : les deux divergent dès que l'utilisateur retape quelque chose
      // après avoir vérifié son code.
      discountCodeInput: '',
      discountCode: '',
      codeVerifie: false,
      discountCodeAmount: 0,
      GUID: props.GUID,
      IsStockPieceDispo : false
    };
    this.sendDevis = this.sendDevis.bind(this);
    this.validatePromoCode = this.validatePromoCode.bind(this);
    this.handleDiscountCodeChange = this.handleDiscountCodeChange.bind(this);
    this.handleEtatFormulaire = this.handleEtatFormulaire.bind(this);
    this.handleSortiePage = this.handleSortiePage.bind(this);

    // Suivi de l'abandon sur le récapitulatif. Hors state React : aucune de ces
    // valeurs n'influence le rendu.
    this.debutRecap = null;
    this.soumis = false;          // devis effectivement envoyé -> pas un abandon
    this.quitteEnvoye = false;    // garde-fou : un seul event de sortie par visite
    this.codePromoTeste = false;
    this.etatFormulaire = { formulaire_demarre: false, champs_remplis: [], nb_tentatives: 0 };
  }

  componentDidMount() {
  const { campaign } = this.props;
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set("campagne", campaign);
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState(null, null, newUrl);

  this.debutRecap = Date.now();

  // pagehide couvre la fermeture d'onglet et la navigation sortante ;
  // visibilitychange rattrape le passage en arrière-plan sur mobile, où
  // pagehide n'est pas garanti.
  window.addEventListener('pagehide', this.handleSortiePage);
  document.addEventListener('visibilitychange', this.handleSortiePage);
  }

  componentWillUnmount() {
    window.removeEventListener('pagehide', this.handleSortiePage);
    document.removeEventListener('visibilitychange', this.handleSortiePage);

    // Démontage sans soumission = retour en arrière dans le wizard.
    if (!this.soumis) {
      this.envoyerQuitte('retour_wizard');
    }
  }

  handleEtatFormulaire(etat) {
    this.etatFormulaire = etat;
  }

  handleSortiePage(event) {
    if (event && event.type === 'visibilitychange' && document.visibilityState !== 'hidden') {
      return;
    }
    this.envoyerQuitte(event && event.type === 'pagehide' ? 'fermeture_page' : 'arriere_plan');
  }

  // Un seul envoi par visite du récapitulatif. Ne contient que des compteurs et
  // des noms de champs — aucune valeur saisie.
  envoyerQuitte(motif) {
    if (this.quitteEnvoye || this.soumis) {
      return;
    }
    this.quitteEnvoye = true;

    const etat = this.etatFormulaire;
    const duree = this.debutRecap ? Math.round((Date.now() - this.debutRecap) / 1000) : null;

    track('devis_recap_quitte', {
      motif: motif,
      duree_s: duree,
      formulaire_demarre: etat.formulaire_demarre,
      champs_remplis: etat.champs_remplis,
      nb_champs_remplis: etat.champs_remplis.length,
      nb_tentatives_envoi: etat.nb_tentatives,
      code_promo_teste: this.codePromoTeste,
      prix_affiche: this.props.showPrices === true,
      nb_prestations: this.props.selectedItems ? this.props.selectedItems.length : 0,
      total: this.props.total,
      campaign: this.props.campaign,
    }, { transport: 'sendBeacon' });
  }

  addRecapItems() {
    return(
      <div className="component-recap-bloc">
        <div className="component-recap-bloc-image">
            {this.printImg()}
        </div>
        <div className="component-recap-bloc-model">
          <div className="component-recap-bloc-model-title">
            {this.printModel()}
          </div>
          <div>
            {this.printSelectedItems()}
          </div>
          {this.props.discountBatterie > 0 &&
          <div className="recap-offre-batterie">
            <DiscountBadge label={"-" + (this.props.offreBatterie != null && Number(this.props.offreBatterie.pourcentage) > 0 ? Number(this.props.offreBatterie.pourcentage) : 50) + "%"} variant="bleu"/>
            {" Offre batterie appliquée sur le remplacement de votre batterie !"}
          </div>}
          <br/>
          <div style={{fontSize: "14px", fontWeight: 600,}}>Le prix total sera affiché sur la prochaine page. ➡️ </div>
        </div>
        {/*
        <div className="component-recap-bloc-prices">
          Total
          <div className="component-recap-bloc-totalAmount">
            {this.printTotal()}
          </div>
          <div>
            {this.printDiscount()}
          </div>
        </div>
        */}
      </div>
    );
  }

  //div protection
  printItemProtection(item) {
    return(
      <label className="lab">
      <div className="item-protection-recapPage">
      <div>
        <img src={item.PictoPath_Piece} className="picto-protection-recapPage"/>
      </div>
      <div className="box-protection">
        <div className="info-box-label-proctection-recapPage">
          {item.Piece}
        </div>
      </div>
      </div>
      </label>);
  }

  printImg() {
    const idPhone = parseInt(this.props.model.IDModele);
    if(idPhone === -1)
      return <img alt ={this.props.category.LibelleCategorie} src={this.props.category.URL_IMG} />;

    return <img alt ={this.props.model.LibelleModele} src={this.props.model.URL_IMG} />;
  }

  printModel() {
    const idCat = parseInt(this.props.category.IDCategorie);
    const idBrand = parseInt(this.props.brand.id);
    const idPhone = parseInt(this.props.model.IDModele);

    //Catégories autres que "Téléphone" ou (catgéorie "Téléphone" et marque "Autre")
    if(idCat !== 2 || idBrand === 0)
      return(this.props.category.LibelleCategorie);

    //Catégorie "Téléphone" et modèle "autre"
    if(idPhone < 1)
      return(this.props.category.LibelleCategorie + " " + this.props.brand.name);

    return(this.props.model.LibelleMarque + " "+this.props.model.LibelleModele);
  }

  printSelectedItems() {
    const items = this.props.selectedItems;

    // Exclure l'élément avec l'ID 2493
    const filteredItems = items.filter(item => item.IDArticle !== 2493);

    if (filteredItems.length === 0)
      return "Aucune réparation sélectionnée";

    // Remise ligne à ligne (TICK00299), affichée uniquement quand les prix le
    // sont : selon la campagne, le récapitulatif peut les masquer.
    const remises = calculerRemisesParItem(filteredItems, this.props.offreBatterie);

    const labels = filteredItems.map((item, index) => {
      const remise = remises[item.IDArticle];
      const prix   = Number(item.PrixTTC) || 0;
      const net    = calculerPrixNet(prix, remise != null ? remise.pourcentage : 0);

      if (!this.props.showPrices)
        return (<div key={index} style={{ margin: '10px 0' }}>{item.Piece}</div>);

      return (
        <div key={index} className="recap-ligne">
          <span className="recap-ligne-libelle">{item.Piece}</span>
          <span className="recap-ligne-prix">
            {remise != null &&
            <span className="recap-prix-barre">{prix.toFixed(2)}€</span>}
            <span className="recap-prix-net">{net.toFixed(2)}€</span>
            {remise != null &&
            <DiscountBadge label={"-" + remise.pourcentage + "%"} variant="bleu"/>}
          </span>
        </div>
      );
    });

    return (
      <div>
        {/*Réparation :*/}
        <div>{labels}</div>
      </div>
    );
  }


//affichage de la div protection si selectionner
  printProtection(item) {
    const items = this.props.selectedItems;

    if (items.find(item => item.IDArticle === 2493)) {
      return (
        <div className="component-phone-data-item-list">

          {proctection_LIST.map(item => (
            <div key={item.IDArticle} className="component-phone-data-item-element">
              {this.printItemProtection(item)}
            </div>
          ))}

        </div>
      );
    }
    return null;
  }

  printTotal() {
    if(this.props.total === 0)
      return "Sur devis";
    if(this.props.showPrices === false)
      return "Page suivante..."
    return (this.props.total-this.state.discountCodeAmount)+"€";
  }

  printDiscount() {
    return "("+(this.props.discount+this.state.discountCodeAmount) +"€ de réduction)";
  }

  addPromoCode() {
    return(
      <form
        className="component-promo-code"
        noValidate
        autoComplete="off"
        onSubmit={this.validatePromoCode}>
        <div className="df-field">
          <label className="df-label" htmlFor="discountCode">Code de réduction</label>
          <div className={"df-input-wrap" + (this.state.discountError ? " df-input-error" : "")}>
            <input id="discountCode" type="text" placeholder="Code de réduction"
                   value={this.state.discountCodeInput}
                   onChange={this.handleDiscountCodeChange}/>
          </div>
          {this.state.discountHelperText !== '' &&
            <p className={this.state.discountError ? "df-error" : "df-success"}>{this.state.discountHelperText}</p>}
        </div>
        <div>
          <button className="validate-button" id="validate-promo-code-button" type="submit">Vérifier le code</button>
        </div>
      </form>
    );
  }

  // Toute frappe invalide la vérification précédente : sans cela, un code validé
  // puis modifié restait appliqué en state et partait à la place du code affiché.
  handleDiscountCodeChange(event) {
    this.setState({
      discountCodeInput  : event.target.value,
      codeVerifie        : false,
      discountCode       : '',
      discountCodeAmount : 0,
      discountHelperText : '',
      discountError      : false
    });
  };

  // Montant en euros à afficher, en français (14,99 € / 20 €).
  formaterMontant(montant) {
    const arrondi = Math.round(montant * 100) / 100;

    if(arrondi === Math.round(arrondi)) {
      return String(arrondi);
    }

    return arrondi.toFixed(2).replace('.', ',');
  };

  async validatePromoCode(event) {
    event.preventDefault();
    const code = this.state.discountCodeInput.trim();

    if(code === '') {
      this.setState({
        discountHelperText: 'Saisissez un code de réduction.',
        discountError: true
      });
      return;
    }

    var discountCode = '';
    var discountCodeAmount = 0;
    var discountHelperText = "Ce code est invalide ou n'est plus valable.";
    var discountError = true;
    var codeVerifie = false;

    const resultat = await APIUtilities.validatePromoCode(code);

    this.codePromoTeste = true;

    if(resultat != null && resultat.valeur > 0) {
      // Un code en pourcentage porte sur le net du panier. Le serveur refait ce
      // calcul à la soumission : c'est lui qui fait foi, l'affichage n'est qu'une
      // annonce.
      if(resultat.estPourcentage) {
        discountCodeAmount = Math.round(this.props.total * (resultat.valeur / 100) * 100) / 100;
        discountHelperText = "Ce code vous fait bénéficier de "+resultat.valeur+"% de réduction, soit "+this.formaterMontant(discountCodeAmount)+"€.";
      } else {
        discountCodeAmount = resultat.valeur;
        discountHelperText = "Ce code vous fait bénéficier de "+this.formaterMontant(discountCodeAmount)+"€ de réduction.";
      }

      discountError = false;
      discountCode = code;
      codeVerifie = true;
    } else if(resultat != null) {
      // Code connu et valide, mais à 0 € (ex. code revendeur) : il ne donne
      // aucune réduction mais doit partir avec le devis pour tracer l'apporteur.
      // Le montant reste à 0, aucune remise n'est affichée.
      discountHelperText = "Code enregistré.";
      discountError = false;
      discountCode = code;
      codeVerifie = true;
    }

    track('devis_code_promo', {
      code: code,
      valide: discountCodeAmount > 0,
      code_reconnu: resultat != null,
      montant_reduction: discountCodeAmount,
      est_pourcentage: resultat != null && resultat.estPourcentage === true,
    });

    this.setState({
      discountCode : discountCode,
      discountCodeAmount : discountCodeAmount,
      discountHelperText: discountHelperText,
      discountError: discountError,
      codeVerifie: codeVerifie
    });
  };

  async sendDevis(event, site) {
    event.preventDefault();
    var details = "";

    // Code saisi mais jamais vérifié : jusqu'ici le devis partait avec
    // CodePromo vide, la remise était perdue sans le moindre message.
    if(this.state.discountCodeInput.trim() !== '' && !this.state.codeVerifie) {
      track('devis_code_promo_non_verifie', {});

      this.setState({
        discountHelperText: 'Cliquez sur « Vérifier le code » avant de valider votre demande.',
        discountError: true
      });

      const champCode = document.getElementById('discountCode');
      if(champCode) {
        champCode.scrollIntoView({ behavior: 'smooth', block: 'center' });
        champCode.focus();
      }

      // Erreur marquée : DataForm ne doit pas afficher son message générique
      // d'échec d'envoi, le message utile est déjà sous le champ.
      const blocage = new Error('Code de réduction non vérifié');
      blocage.blocageUtilisateur = true;
      throw blocage;
    }

    this.state.IDSite = site;

    if(this.props.selectedItems.length === 0)
      details = event.target.details.value;

    let res =await APIUtilities.sendDevis(event.target.prenom.value,
                                 event.target.name.value,
                                 event.target.email.value,
                                 event.target.phone.value.replace(/ /g, ""),
                                 site,
                                 this.state.GUID,
                                 this.props.selectedItems,
                                 details,
                                 this.state.discountCode,
                                 this.props.campaign);

    // sendDevis retourne null si le fetch a échoué ou si la réponse n'était pas
    // du JSON (ex : page HTML 504 du reverse proxy). Sans cette garde, l'accès à
    // res.data plantait en silence : aucun message à l'utilisateur, devis perdu.
    if (!res || !res.data) {
      track('devis_erreur_api', {
        endpoint: 'addDevis',
        message: 'réponse absente ou invalide après soumission du formulaire',
      });
      throw new Error('Réponse invalide du serveur lors de l\'envoi du devis');
    }

    console.log('res');
    console.log(res.data);
    let IsStockPieceDispo = false;

    if(res.data.TotalCommande == res.data.TotalStock && res.data.TotalCommande > 0) {
      IsStockPieceDispo = true;
    }
    console.log('IsStockPieceDispo->',IsStockPieceDispo);

    // Devis parti : le démontage qui suit ne doit pas être compté comme un abandon.
    this.soumis = true;

    this.props.onClickFunction(this.state.discountCodeAmount, site, IsStockPieceDispo);
  }

  render() {
    return (
      <>
      <div className="component-recap-page">
        <h1 className="component-recap-page-title">Récapitulatif de ma demande</h1>

        <p className="component-recap-page-info">Bénéficiez de {normaliserParametres(this.props.offreBatterie).tauxWeb}% de remise immédiate en remplissant vos coordonnées ci-dessous, un conseiller vous contactera dans les plus brefs délais pour prendre rendez-vous avec vous.</p>
        <p className="component-recap-page-info">Ce devis est valable en boutique Phoner pour une durée de 1 mois !</p>
        {this.addRecapItems()}
        {this.printProtection()}
        {/*<div className="component-recap-add-info">Le prix total sera affiché dans la prochaine page.</div>*/}
        {this.addPromoCode()}
        <Router>
        <DataForm onSubmit={this.sendDevis} onEtatFormulaire={this.handleEtatFormulaire} details={this.props.selectedItems.length === 0 ? 1 : 0}/>
        </Router>
        {/*<div className="sub-info">
        Un de nos techniciens prendra contact avec vous pour définir une date de rendez vous en boutique sous 24h
        </div>*/}
      </div>
      </>
    );
  }
}

export default RecapPage;
